var map = {
	"./mechelen.jpg": 5539,
	"./pont-du-gard.jpg": 3139,
	"./stave-church.mp4": 1784,
	"./tate-modern.jpg": 551,
	"./tate-modern2.jpg": 8326,
	"./video-benefits.mp4": 7334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6106;